module.exports = __webpack_public_path__ + "img/congrex-logo-v2.a3682734.png";